import { useEffect, useRef, useState } from "react";

const useReorder = (items, saveReorder) => {
  const [ordered, setOrdered] = useState(items || []);
  const dragIdRef = useRef(null);

  useEffect(() => {
    if (items) setOrdered(items);
  }, [items]);

  const handleDragStart = (e, id) => {
    dragIdRef.current = id;
    e.dataTransfer.setData("text/plain", String(id));
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = (targetId) => {
    const draggedId = dragIdRef.current;
    if (!draggedId || draggedId === targetId) return;
    const fromIndex = ordered.findIndex((i) => i.id === draggedId);
    const toIndex = ordered.findIndex((i) => i.id === targetId);
    if (fromIndex === -1) return;
    const next = [...ordered];
    const [item] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, item);
    setOrdered(next);
    dragIdRef.current = null;
    if (saveReorder) saveReorder(next.map((i) => i.id));
  };

  return { ordered, handleDragStart, handleDragOver, handleDrop };
};

export default useReorder;
